import { InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useSearchParams } from '@/hooks/useSearchParams';
import { useCallback, useEffect } from 'react';
import { ISelectPaymentParams } from '@/types/base';
import * as Styled from './SelectLanguage.styles';

const LANGUAGES = ['en', 'es', 'de', 'fr', 'ja'];

const LanguageLabel = 'Language';

export const SelectLanguage = () => {
  const languages = LANGUAGES.slice();

  const { parsedSearchParams, mergeSearchParams } =
    useSearchParams<ISelectPaymentParams>();
  const { lang } = parsedSearchParams || '';

  useEffect(() => {
    if (languages?.length && lang === undefined) {
      mergeSearchParams({
        lang: languages[0],
      });
    }
  }, [mergeSearchParams, languages, lang]);

  const handleLanguageChange = useCallback(
    (event: SelectChangeEvent) => {
      mergeSearchParams({
        lang: event?.target.value,
      });
    },
    [mergeSearchParams],
  );

  return (
    <Styled.FormControl>
      <InputLabel>{LanguageLabel}</InputLabel>
      <Select label={LanguageLabel} value={lang || ''} onChange={handleLanguageChange}>
        <MenuItem value=' '>None</MenuItem>
        <MenuItem value='null'>Null</MenuItem>
        {languages?.map((option) => (
          <MenuItem key={option} value={option}>
            {option.toUpperCase()}
          </MenuItem>
        ))}
        <MenuItem value='///'>///</MenuItem>
      </Select>
    </Styled.FormControl>
  );
};
